/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
/** @packageDocumentation
 * @module Common
 */

/**
 * Enumeration of orientation.
 * @public
 * @deprecated in 4.16.0. Use {@link @itwin/components-react#Orientation} instead.
 */
export enum Orientation {
  Horizontal,
  Vertical,
}
